import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { apiClient } from "shared/api/client";
import { alertDialog } from "shared/ui/feedback";

// true면 handong 도메인 제한을 해제한다(모든 도메인 허용).
// 미설정/false면 기존 동작대로 handong.ac.kr, handong.edu만 허용.
const ALLOW_ALL_LOGIN_DOMAINS =
  process.env.REACT_APP_ALLOW_ALL_LOGIN_DOMAINS === "true";

function Redirect() {
  const code = new URLSearchParams(document.location.search).get("code");
  const hd = new URLSearchParams(document.location.search).get("hd");
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_URL;

  useEffect(() => {
    const getUserId = async () => {
      try {
        const res = await apiClient.get("/adminLogin/oauth/google", {
          // Backward/forward compatibility:
          // some backend versions expect `code`, others `oauthCode`.
          params: { code: code, oauthCode: code },
        });
        if (res.data.token === null) {
          alertDialog("로그인 권한이 없는 계정입니다.");
          navigate("/login", { replace: true });
        } else {
          localStorage.setItem("admintoken", res.data.token);
          alertDialog("로그인이 완료 되었습니다.");
          navigate("/", { replace: true });
        }
      } catch (error) {
        alertDialog("서버 연결에 실패했습니다. 잠시 후 다시 시도해주세요.");
        navigate("/login", { replace: true });
        // console.error("Error:", error);
      }
    };

    if (!ALLOW_ALL_LOGIN_DOMAINS && hd !== "handong.ac.kr" && hd !== "handong.edu") {
      alertDialog("로그인이 할 수 없는 이메일입니다");
      navigate("/login", { replace: true });
    } else if (!apiBaseUrl) {
      alertDialog("서버 주소가 설정되지 않았습니다.");
      navigate("/login", { replace: true });
    } else {
      getUserId();
      // alertDialog("로그인 가능 이메일입니다");
    }
  }, [apiBaseUrl, code, hd, navigate]);

  return <div>로그인 처리 중입니다...</div>;
}
export default Redirect;

export const getUserInfo = async () => {
  const response = await apiClient.get("/appUsers/myProfile");

  return response.data;
};
